import React from 'react'

const TermsAndCondition = () => {
  return (
    <div className='container mb-3'>
      <h2>Terms and Conditions</h2>
      <p><strong>Effective Date:</strong> 26th October 2024</p>
      <h4 className='mt-3'>1. Acceptance of Terms</h4>
      <p>By accessing and using the services provided by Monarchinstitute.in you agree to comply with these Terms and Conditions. If you do not agree, please refrain from using our services.</p>
      <h4 className='mt-3'>2. Services Provided</h4>
      <p>Monarch Institute offers online courses and educational resources. Details regarding course offerings, schedules, and pricing can be found on our website.</p>
      <h4 className='mt-3'>3. Registration and Account Security</h4>
      <p>Users must create an account to access certain services.<br></br>
        You are responsible for maintaining the confidentiality of your account credentials.<br></br>
        Notify us immediately of any unauthorized use of your account.</p>
      <h4 className='mt-3'>4. Payment Terms</h4>
      <p>All fees must be paid in full before accessing course materials.<br></br>
      Refund policies are outlined separately and can be found on our website.</p>
      <h4 className='mt-3'>5. Intellectual Property</h4>
      <p>All content provided by Monarchinstitute.in, including course materials, videos, and assessments, is protected by copyright. Users may not reproduce, distribute, or modify this content without prior written consent.</p>
      <h4 className='mt-3'>6. User Conduct</h4>
      <p>Users agree to engage in respectful and constructive behavior.<br></br>
      Harassment, discrimination, or any form of misconduct will not be tolerated and may result in account termination</p>
      <h4 className='mt-3'>7. Limitation of Liability</h4>
      <p>Monarchinstitute.in is not liable for any indirect, incidental, or consequential damages resulting from the use of our services.</p>
      <h4 className='mt-3'>8. Modifications to Terms</h4>
      <p>We reserve the right to update these Terms and Conditions at any time. Users will be notified of significant changes via email or through our website.</p>
      <h4 className='mt-3'>9. Contact Information</h4>
      <p>If you have any questions regarding these Terms and Conditions, please contact us:
        <br></br>
        Email : <a>info@monarchinstitute.in</a><br></br>
        Phone Number: 9136431685
      </p>
    </div>
  )
}

export default TermsAndCondition
